import React from 'react';
import { Form, Formik } from 'formik';
import { SelectInput } from '../../../../../components/form';
import { useQuery } from '@tanstack/react-query';
import appCategoryService from '../../../../../services/api/apps/appCategoryService';


function AppProvidersListFilters({ initialData, onSearch, searching }: Props) {

    const queryKey = ['payments', 'apps', 'categories', { pageSize: 50 }];
    //const queryClient = useQueryClient();
    const categoriesQuery = useQuery({
        queryKey: queryKey,
        queryFn: () => appCategoryService.getCategories({ pageSize: 50 }),
        staleTime: Infinity,
        retryDelay: Infinity,
        refetchOnWindowFocus: false, // Disable refetching on window focus
        refetchOnMount: false, // Disable refetching on component mount
        refetchInterval: false, // Disable interval-based refetching
    });


    const handleSubmit = (values: any, { reset }: any) => {
        onSearch(values);
    }


    return (
        <Formik
            initialValues={{
                appCategoryId: initialData['appCategoryId'] || '',
            }}
            onSubmit={handleSubmit}
        >
            {({ errors, touched, setErrors, submitCount, isValid, values, setFieldValue }) => (
                <Form className="flex-grow flex items-center mr-8 mb-4">
                    <div className='mr-6'>
                        <SelectInput
                            items={categoriesQuery.data?.data}
                            placeholder="Select category"
                            value={values["appCategoryId"]}
                            valueKey='id'
                            labelKey='name'
                            onChange={(item: any) => setFieldValue("appCategoryId", item?.id)}
                            clearable
                        />
                    </div>
                    <button type='submit' className='text-blue-500 hover:text-blue-600 disabled:text-blue-400 px-2' disabled={searching}>Search</button>
                </Form>
            )}
        </Formik>
    );
}


interface Props {
    initialData: any;
    onSearch: (values: any) => void;
    searching: boolean;
}


export default AppProvidersListFilters;